// @oasis-permission-inherits: /ai-edits (studio-edits:view)
import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/ai-edits/cactus-tools")({
  component: RouteComponent,
  beforeLoad() {
    ensureSession();
  },
});

function RouteComponent() {
  return <Outlet />;
}
